const login = {
  "account": "Account",
  "password": "Password",
  "rememberAccount": "Remember account",
  "accountTip": "Please enter your account number!",
  "smsLogin": "SMS Login",
  "accountLogin": "Account Login",
  "passwordTip": "Please enter your password!",
  "verifyCode": "Verify Code",
  "verifyCodeTip": "Please enter verify code!",
  "verifyCodeLengthTip": "The verify code length is 4!",
  "phoneNumber": "Phone number",
  "login": "Login",
  "smsVerifyCode": "SMS verify code",
  "sendSms": "Send SMS",
  "loginSuccess": "Login success",
  "welcome": "welcome!",
  "phoneNumberFormatError": "Wrong format of phone number!",
  "verifyCodeLengthError": "The verify code length is incorrect!",
  "verifyCodeIsNull": "Please enter the verify code!",
  "sendAgain": "seconds send again",
  "intelligentPositionSystem":"Intelligent Position System",
  "usernameOrPasswordError":"The username or password is incorrect!",
  "beian":"Beijing ICP Filing No. 16017149-1",
  
}
export default login